import { DownOutlined, LogoutOutlined } from '@ant-design/icons';
import { Avatar, Button, Dropdown, Layout, Space, Typography } from 'antd';
import { useTranslation } from 'react-i18next';
import { useAuth } from '../auth/AuthContext';
import { useLocale } from '../hooks/useLocale';
import LocalizedText from '../components/LocalizedText';

const { Header } = Layout;

export default function AppHeader() {
  const { t } = useTranslation();
  const { user, logout } = useAuth();
  const { locale, toggleLocale } = useLocale();

  const menuItems = [
    {
      key: 'logout',
      icon: <LogoutOutlined />,
      label: t('common.logout'),
      onClick: logout,
    },
  ];

  return (
    <Header className="app-header">
      <div className="app-header__context">
        <Typography.Text type="secondary">{t('app.subtitle')}</Typography.Text>
      </div>
      <Space size={10}>
        <Button className="app-header__language" size="small" onClick={toggleLocale}>
          {locale === 'ar' ? 'EN' : 'ع'}
        </Button>
        <Dropdown menu={{ items: menuItems }} placement="bottomRight" trigger={['click']}>
          <Space className="app-header__profile">
            <Avatar size={32}>{user?.fullName?.ar?.[0] || user?.fullName?.en?.[0] || 'م'}</Avatar>
            <span className="app-header__profile-name">
              <LocalizedText value={user?.fullName} />
            </span>
            <DownOutlined className="app-header__profile-arrow" />
          </Space>
        </Dropdown>
      </Space>
    </Header>
  );
}
